<template>
    <v-slide-y-transition v-if="$route.path === '/' && !user">
            <v-alert
            class="global-alert ma-0 text-center"
            tile
            color="#5C3057"
            dark
            prominent
            v-if="alert"
            >
                <v-btn
                    icon
                    small
                    absolute
                    right
                    class="close-button"
                    @click="alert = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <span v-html="$t('home.global-alert')"></span>
            </v-alert>
    </v-slide-y-transition>
</template>

<script>
    export default {
        name: 'GlobalAlert',
        props: {
            user: {
                type: Object,
                required: false,
                default: null
            }
        },
        data() {
            return {
                alert: true
            };
        }
    }
</script>

<style scoped>
.global-alert {
  height: 76px !important;
  color: #E0BCF7 !important;
  font-size: 15px;
  font-weight: 600;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.close-button {
  position: absolute !important;
  right: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #E0BCF7 !important;
}
</style>
